import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpRequests} from '../../helpers/core/http.requests';
import {RequestUrls} from '../../helpers/routes/request.urls';
import {DataSharing} from '../../helpers/core/data.sharing';
import {CommonFunctions} from '../../helpers/core/common.functions';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    public _name: string;
    public _settings: any;

    constructor(private c_f: CommonFunctions, private h_r: HttpRequests, private r_u: RequestUrls, private r_c: Router) {
    }

    ngOnInit() {
        const portal_setting = DataSharing.GetJsonObj('settings');
        this._settings = {
            logo: portal_setting.logo,
            logo_description: portal_setting.logo_description
        };
        this._name = DataSharing.GetJsonObj('info').name;
    }

    public Logout() {
        this.c_f.setLoading(true);
        const url = this.r_u.getUrl('logout');
        this.h_r.HttpGet(url).subscribe(response => {
            if (response.status) {
                DataSharing.clearAll();
                this.c_f.ShowToast(response.message, 'success');
                this.r_c.navigate(['login']);
            } else {
                this.c_f.ShowToast(response.message, 'danger');
            }
            this.c_f.setLoading(false);
        });
    }

}
